import { render } from "./AdminEducationSections.vue?vue&type=template&id=3c92481c&scoped=true&ts=true"
import script from "./AdminEducationSections.vue?vue&type=script&lang=ts"
export * from "./AdminEducationSections.vue?vue&type=script&lang=ts"

import "./AdminEducationSections.vue?vue&type=style&index=0&id=3c92481c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c92481c"]])

export default __exports__